export interface MenuItemPaths {
    linkPathname: string;
    extraPaths: Array<string>;
}

const noMatch = -1;

export function isMenuItemActive(pathname: string, rootRoutePathname: string, menuItem: MenuItemPaths) {
    return getMatchLength(pathname, rootRoutePathname, menuItem) !== noMatch;
}

// Paths are matched as substrings and sub menu paths can nest, like /privacy/dashboard and /privacy/dashboard/contracts,
// so the inner page matches both. Only the most specific match is the active one.
export function getActiveSubMenuItemIndex(pathname: string, rootRoutePathname: string, subMenuItems: Array<MenuItemPaths>) {
    const matchLengths = subMenuItems.map((subMenuItem) => getMatchLength(pathname, rootRoutePathname, subMenuItem));
    const longestMatchLength = Math.max(noMatch, ...matchLengths);
    return longestMatchLength === noMatch ? undefined : matchLengths.indexOf(longestMatchLength);
}

function getMatchLength(pathname: string, rootRoutePathname: string, menuItem: MenuItemPaths) {
    // The root path shows the page the user lands on, so that page's menu item is active there
    if (pathname === "/" && menuItem.linkPathname === rootRoutePathname) {
        return menuItem.linkPathname.length;
    }

    const matchingPaths = [menuItem.linkPathname, ...menuItem.extraPaths].filter((path) => pathname.includes(path));
    if (matchingPaths.length === 0) {
        return noMatch;
    }

    // Extra paths are written without the leading slash the link has
    return Math.max(...matchingPaths.map((path) => path.replace(/^\//, "").length));
}
